import { Form, Field as FormikField } from 'formik';
import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import { default as BaseText } from '@rsos/components/capstone/base/Text';
import { InputStyles } from '@rsos/components/capstone/base/form/inputs/InputText/InputText.styles';

export const StyledHeader = styled(Box)`
  padding: 16px 15px;
`;

export const StyledButtonContainer = styled(Box)`
  padding: 10px 15px;
  border-top: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
`;

export const StyledAviveSearchForm = styled(Box)`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.background};
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  overflow: auto;
`;

export const StyledInput = styled.input.attrs({
  'data-lpignore': 'true',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
})`
  ${InputStyles}
  padding: 10px;
`;

export const Field = styled(FormikField).attrs({
  'data-lpignore': 'true',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
})`
  ${InputStyles}
  padding: 10px;
`;

export const StyledFormGroup = styled(Box)`
  padding: 15px;
  min-height: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Text = styled(BaseText)`
  display: inline-flex;
`;

export const ButtonBox = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  padding: 5px;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
  input[type='radio'] {
    margin: 0;
    margin-right: 7px;
  }
  margin: 4px 0;
  &:first {
    margin-top: 0;
  }
`;

export const StyledTextArea = styled.textarea`
  display: block;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  width: 100%;
  height: 75px;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  margin-top: 6px;
  padding: 10px;
  resize: none;
  ::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }
  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryBase};
    outline: 0;
  }
  border-color: ${p =>
    p.error ? p.theme.colors.lightDanger : p.theme.colors.heavyLineOutline};
`;
